import contractFields from '../../../fields/contractFields';
import DropdownContractActionsRow from '../../dropdown/DropdownContractActionsRow';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import RenderApplication from '../../application/RenderApplication';
import RenderBankCode from '../../bankCode/RenderBankCode';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import ColumnSelection from '@/common-utils/components/renders/dataTable/column/ColumnSelection';

export const columnsContractFromProviderId = 'contractsFromProvider';
export const columnsContractFromProvider = (headerPackage) => {
    const show = false;

    return ([
        // ColumnSelection
        headerPackage.selectionMode && ColumnSelection(columnsContractFromProviderId),
        // Columns
        generateColumnDefByField({
            field: contractFields.UUID,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                row &&
                <DropdownContractActionsRow contract={row.original} setLaunchRefetch={headerPackage.setLaunchRefetch} />
            ),
            show: !headerPackage.selectionMode
        }),
        generateColumnDefByField({
            field: contractFields.APPLICATION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                if (!cell) {
                    return null;
                }
                const itp = getObjectAttributeFromStringKey(cell.row.original, generateNestedFieldAccessor(contractFields.ITP)) || '';
                const posTerminalSerialNumber = getObjectAttributeFromStringKey(cell.row.original, generateNestedFieldAccessor(contractFields.POS_TERMINAL.SERIAL_NUMBER))
                    || '';
                return (
                    <RenderApplication
                        itp={itp}
                        applicationCode={cell.getValue(contractFields.APPLICATION.key)}
                        posTerminalSerialNumber={posTerminalSerialNumber}
                    />
                );
            }
        }),
        generateColumnDefByField({
            field: contractFields.LAST_REMOTE_COLLECTION_DATE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime
                    value={cell.getValue(contractFields.LAST_REMOTE_COLLECTION_DATE.key)}
                    errorMessage={'merchantContract_last_remote_outdated_error'}
                    warningMessage={'merchantContract_last_remote_outdated_warning'}
                />
            )
        }),
        generateColumnDefByField({
            field: contractFields.NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: contractFields.BANK_CODE,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderBankCode bankCode={cell.getValue(contractFields.BANK_CODE.key)} />
            )
        }),
        generateColumnDefByField({
            field: contractFields.RANK,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: contractFields.LEGAL_BUSINESS_NAME,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: contractFields.REGISTRATION_NUMBER,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                <small>{cell.getValue(contractFields.REGISTRATION_NUMBER.key)}</small>
            )
        }),
        generateColumnDefByField({
            field: contractFields.POS_TERMINAL.MANUFACTURER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.MODEL,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.POS_TERMINAL.SERIAL_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: contractFields.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: contractFields.X25_ADDRESS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                <small>{cell.getValue(contractFields.X25_ADDRESS.key)}</small>
            )
        }),
        generateColumnDefByField({
            field: contractFields.ITP,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                <small>{cell.getValue(contractFields.ITP.key)}</small>
            )
        }),
        generateColumnDefByField({
            field: contractFields.CB_VERSION,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell && cell.getValue(contractFields.CB_VERSION.key) &&
                <span>{cell.getValue(contractFields.CB_VERSION.key).replace(/^CB/, '')}</span>
            )
        }),
        generateColumnDefByField({
            field: contractFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(contractFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: contractFields.LAST_ICCID,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.SPECIFICATION,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.BULLETINS,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.ERT_CODE,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.CB_AGREEMENT_NUMBER,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.CB_AGREEMENT_DATE,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.PCI_VERSION,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.PCI_EXPIRATION_DATE,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.PCI_PP_VERSION,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.PCI_PP_EXPIRATION_DATE,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.EXPIRATION_DATE,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.END_OF_DEPLOYMENT_DATE,
            headerPackage: headerPackage,
            show: show
        }),
        generateColumnDefByField({
            field: contractFields.REMPART.END_OF_USE_DATE,
            headerPackage: headerPackage,
            show: show
        })
    ].filter(col => !!col));
};